(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-drops-feature"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mr-drops-carousel]').forEach((root) => {
    const track = root.querySelector('[data-mr-drops-track]');
    const slides = Array.from(root.querySelectorAll('[data-mr-drops-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-mr-drops-dot]'));
    if (!track || slides.length < 2) return;

    const index = () => Math.round(track.scrollLeft / track.clientWidth);
    const goTo = (i) => {
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    };
    const sync = () => {
      const i = index();
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    };

    root.querySelector('[data-mr-drops-prev]')?.addEventListener('click', () => goTo(index() - 1));
    root.querySelector('[data-mr-drops-next]')?.addEventListener('click', () => goTo(index() + 1));
    dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.mrDropsDot))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
    });

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
